
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from "@mui/material";
import { useState } from "react";
import { getIsoDate } from 'utils';
import DatePickerContainer from './DatePickerContainer';
import { getDateFnsFormatString } from 'assets/constants';
import { connect } from 'react-redux';
import { IconArrowDropDown, IconCalendar } from 'assets/icons';

const CustomPicker = styled(DatePicker)(({theme}) => ({
    '& .MuiFormHelperText-root': {
        marginLeft: 0,
        marginBottom: theme.spacing(1.5),
    }
}));

const MobileDatePicker = ({ lngCode, name, value, helperText, required, onBlur, error, ...props}) => {

    const [open,setOpen] = useState(false);
//Adorment left
    return (
        <>
            <DatePickerContainer>
                <CustomPicker                    
                    open={open}
                    onClose={() => setOpen(false)}
                    onOpen={() => setOpen(true)}
                    monthsPerRow={3}
                    yearsPerRow={3}
                    views={['year', 'month', 'day']}
                    slotProps={{ textField: { value, helperText, required, onBlur, error, title: value } }}
                    {...props}
                    disableToolbar
                    format={getDateFnsFormatString(lngCode)}
                    dateFormat="M/d/yyyy"
                    dayOfWeekFormatter={(day) => new Intl.DateTimeFormat(lngCode, { weekday: 'short' }).format(day)}
                    slots={{ 
                         switchViewIcon: (props) => <IconArrowDropDown {...props} />,
                         openPickerIcon: (props) => <IconCalendar {...props}  />
                    }}

                />
            </DatePickerContainer>
            <input {...{name}} value={value ? getIsoDate(value) : ''} readOnly hidden aria-label='hidden input' />
        </>
    )
}

export default connect(({ current: { general: { language: { lngCode } } } }) => ({ lngCode }))
    (MobileDatePicker);